import axios from 'axios';

const libraryBookIssue = {
    namespaced: true,
    
	actions: {		
		ProcessLibraryBookIssue(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/LibraryBookIssue/ProcessLibraryBookIssue', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 		
		GetLibraryBookIssue({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBookIssue/GetLibraryBookIssue?Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 
		GetByIdLibraryBookIssue({rootState}, Id){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBookIssue/GetByIdLibraryBookIssue?Id=${Id}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		ReturnLibraryBookIssue({rootState}, {Id, ReturnDate}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBookIssue/ReturnLibraryBookIssue?Id=${Id}&ReturnDate=${ReturnDate}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		GetLibraryBookIssueNotReturn({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBookIssue/GetLibraryBookIssueNotReturn?Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		},
		GetLibraryBookIssueReturn({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBookIssue/GetLibraryBookIssueReturn?Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}
	}
}

export default libraryBookIssue